import React from "react";
import { AlertOctagon, AlertTriangle, Check } from "react-feather";
import styled, { css } from "styled-components";

interface Props {
  warn?: string | boolean;
  error?: string | boolean;
  success?: string | boolean;
  placeholder?: string;
  className?: string;
  padBottom?: boolean;
  padTop?: boolean;
}

const StyledBanner = styled.div<{
  $type: string;
  $padBottom?: boolean;
  $padTop?: boolean;
}>`
  margin: auto;
  width: fit-content;
  padding: 3px 10px;
  border-radius: 15px;
  font-size: 15px;
  display: flex;
  align-items: center;
  min-height: 30px;

  svg {
    margin-right: 5px;
  }

  ${(props) =>
    props.$type === "error" &&
    css`
      background-color: var(--redBackground);
      color: var(--red500);
      border: 1px solid var(--redBorderOverlay);
    `}

  ${(props) =>
    props.$type === "warn" &&
    css`
      background-color: var(--orangeBackground, rgba(255, 140, 0, 0.12));
      color: var(--orange400);
      border: 1px solid var(--orangeBorder);
    `}

  ${(props) =>
    props.$type === "success" &&
    css`
      color: var(--green300);
    `}

  ${(props) =>
    props.$type === "placeholder" &&
    css`
      color: var(--dark700);
    `}

  ${(props) =>
    props.$padTop &&
    css`
      margin-top: 20px;
    `}

  ${(props) =>
    props.$padBottom &&
    css`
      margin-bottom: 20px;
    `}
`;

const Banner = (props: Props) => {
  const { warn, error, placeholder, success, className, padBottom, padTop } =
    props;
  const type = error
    ? "error"
    : warn
    ? "warn"
    : success
    ? "success"
    : placeholder
    ? "placeholder"
    : "";
  const message = error
    ? error !== true
      ? error
      : "Unexpected error"
    : warn
    ? warn !== true
      ? warn
      : "Unsaved changes"
    : success
    ? success !== true
      ? success
      : "Saved"
    : placeholder ?? "";

  if (!type) {
    return <></>;
  }
  return (
    <StyledBanner
      $type={type}
      className={className}
      $padBottom={padBottom}
      $padTop={padTop}
    >
      {type === "error" ? (
        <AlertOctagon size={17} />
      ) : type === "warn" ? (
        <AlertTriangle size={17} />
      ) : type === "success" ? (
        <Check size={17} />
      ) : undefined}
      {message}
    </StyledBanner>
  );
};

export default Banner;
